<template>
	<div class="vrMGT">
		<el-button v-if="permissionAdd" type="primary" @click="AddDialogTableVisible = true" class="AddVillageBtn margin-bottom-10"><i class="el-icon-edit"></i> 新增</el-button>
		<div style="float: right;">
			<el-input v-model="searchName" placeholder="请输入VR名称进行搜索" style="width:200px" @keyup.enter.native="handleSearch"></el-input>
			<el-button slot="append" icon="el-icon-search" type="primary" @keyup.enter="handleSearch" @click="handleSearch" style="margin-left:10px;">搜索</el-button>
		</div>
		<el-table
			v-if="permissionShow"
			v-loading="loading"
			element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"
			:data="tableData"
			border
			style="width: 100%; margin-top:10px;"
			height="calc(100% - 100px)">
			<!--<el-table-column prop="vr_id" label="序号" sortable align="center"  min-width="90"></el-table-column>-->
			<el-table-column prop="vr_name" label="名称" sortable align="center" min-width="160"></el-table-column>
			<el-table-column prop="vr_icon" label="图标" sortable align="center" min-width="160">
				<template slot-scope="scope">
					<img :src="scope.row.vr_icon" height="34px" class="showImg" @click="showImg(scope.row)">
				</template>
			</el-table-column>
			<el-table-column prop="vr_url" label="地址" sortable align="center" min-width="220"></el-table-column>
			<el-table-column prop="vr_issupport" label="是否支持VR体验标识" sortable align="center" min-width="220"></el-table-column>
			<el-table-column
				label="操作"
				align="center"
				min-width="180"
				v-if="permissionEdit || permissionDetail || permissionDelete">
				<template slot-scope="scope">
					<el-button v-if="permissionDetail" @click="handleDetail(scope.row)" type="text" size="small">查看</el-button>
					<el-button v-if="permissionEdit" @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
					<el-button v-if="permissionDelete" @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<div id="pagination">
			<el-pagination
				background
				layout="prev, pager, next"
				:total="total"
				:page-size="limit"
				@current-change="handleCurrentChange">
			</el-pagination>
		</div>

		<!-- 新建模态框 -->
		<el-dialog 
			:visible.sync="AddDialogTableVisible"
			title="新建VR链接" 
			top="60px"
			width="40%"
			@closed="cancleAddForm('AddForm')"
			:close-on-click-modal="false">
			<!-- 表单 -->
			<el-form ref="AddForm" :model="AddForm" label-width="140px" :rules="Rules" style="width:100%;">
				<el-form-item label="VR名称" prop="vr_name">
					<el-input v-model="AddForm.vr_name"></el-input>
				</el-form-item>
				<el-form-item label="介绍" prop="vr_tntroduce">
					<el-input type="textarea" v-model="AddForm.vr_tntroduce" rows="4"></el-input>
				</el-form-item>
				<el-form-item label="图标" prop="vr_icon">
					<el-upload
						:class="{disabled:uploadDisabled1}"
						:action="UploadUrl"
						ref="AddUpload"
						:http-request="customUploadCover"
						list-type="picture-card"
						:file-list="addUploadFileList"
						:on-preview="handlePreview"
						:on-remove="handleAddUploadRemove"
						:limit="1"
						:before-upload="beforeUploadCover">
						<i class="el-icon-plus"></i>
					</el-upload>
						<!-- :on-success="handleAddUploadSuccess" -->
					<p style="margin:0;color:red">图片格式：".bmp", ".jpg", ".jpeg", ".png"</p>
				</el-form-item>
				<el-form-item label="支持VR体验" prop="vr_issupport" label-width="130px">
					<el-radio v-model="AddForm.vr_issupport" label="1">是</el-radio>
					<el-radio v-model="AddForm.vr_issupport" label="0">否</el-radio>
				</el-form-item>
				<el-form-item label="地址" prop="vr_url">
					<el-input v-model="AddForm.vr_url"></el-input>
				</el-form-item>
				<el-form-item class="text-align-right">
					<el-button type="primary" @click="submitAddForm('AddForm')">提交</el-button>
					<el-button @click="cancleAddForm('AddForm')">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 查看模态框 -->
		<el-dialog 
			:visible.sync="DetailDialogTableVisible"
			title="查看VR链接"
			class="detailDialog"
			top="60px"
			width="760px"
			@closed="cancleDetailForm('DetailForm')"
			:close-on-click-modal="false">
			<el-form ref="DetailForm" :model="DetailForm" label-width="120px" style="width:100%;">
				<el-form-item label="VR名称" prop="vr_name">
					<el-input v-model="DetailForm.vr_name" readonly></el-input>
				</el-form-item>
				<el-form-item label="介绍" prop="vr_tntroduce">
					<el-input type="textarea" v-model="DetailForm.vr_tntroduce" rows="4" readonly></el-input>
				</el-form-item>
				<el-form-item label="图标" prop="vr_icon">
					<el-upload
						:class="{disabled:uploadDisabled2}"
						:action="UploadUrl"
						list-type="picture-card"
						:on-preview="handlePreview"
						:limit="1"
						:before-upload="beforeUploadCover"
						:file-list="detailUploadFileList"
						disabled>
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="支持VR体验" prop="vr_issupport" label-width="130px">
					<el-radio v-model="DetailForm.vr_issupport" label="1" disabled>是</el-radio>
					<el-radio v-model="DetailForm.vr_issupport" label="0" disabled>否</el-radio>
				</el-form-item>
				<el-form-item label="地址" prop="vr_url">
					<el-input v-model="DetailForm.vr_url" readonly></el-input>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 编辑模态框 -->
		<el-dialog 
			:visible.sync="EditDialogTableVisible"
			title="修改VR链接" 
			top="60px"
			width="760px"
			@closed="cancleEditForm('EditForm')"
			:close-on-click-modal="false">
			<el-form ref="EditForm" :model="EditForm" label-width="120px" :rules="Rules" style="width:100%;">
				<el-form-item label="VR名称" prop="vr_name">
					<el-input v-model="EditForm.vr_name"></el-input>
				</el-form-item>
				<el-form-item label="介绍" prop="vr_tntroduce">
					<el-input type="textarea" v-model="EditForm.vr_tntroduce" rows="4"></el-input>
				</el-form-item>
				<el-form-item label="图标" prop="vr_icon">
					<el-upload
						:class="{disabled:uploadDisabled3}"
						:action="UploadUrl"
						list-type="picture-card"
						ref="EditUpload"
						:http-request="EditUploadCover"
						:on-preview="handlePreview"
						:on-remove="handleEditUploadRemove"
						:limit="1"
						:before-upload="beforeUploadCover"
						:file-list="editUploadFileList">
						<i class="el-icon-plus"></i>
					</el-upload>
						<!-- :on-success="handleEditUploadSuccess" -->
				</el-form-item>
				<el-form-item label="支持VR体验" prop="vr_issupport" label-width="130px">
					<el-radio v-model="EditForm.vr_issupport" label="1">是</el-radio>
					<el-radio v-model="EditForm.vr_issupport" label="0">否</el-radio>
				</el-form-item>
				<el-form-item label="地址" prop="vr_url">
					<el-input v-model="EditForm.vr_url"></el-input>
				</el-form-item>
				<el-form-item class="text-align-right">
					<el-button type="primary" @click="submitEditForm('EditForm')">提交</el-button>
					<el-button @click="cancleEditForm('EditForm')">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 放大首图 -->
		<el-dialog 
			:visible.sync="ImgDialog"
			:title="currentImg.vr_name +'图标'" 
			top="4%"
			width="30%"
			:close-on-click-modal="false">
			<img :src="currentImg.vr_icon" width="100%">
		</el-dialog>
	</div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

export default {
	name: 'vrMGT',
	data() {
		// url验证
		var checkURL = (rule, value, callback) => {        
			if (!value) {     
				return callback(new Error('地址不能为空'));         
			} else {          
				const reg = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/
				console.log(reg.test(value));          
				if (reg.test(value)) {            
					callback();         
				} else {            
					return callback(new Error('必须以http/https/ftp/ftps开头,且不能包含双字节符号或非链接特殊字符'));          
				}     
			}
		};
		return {
			/* 
			 * tableData: 表格数据
			 * loading: 加载状态（默认为true）
			 * total: 总条数（table数据总长度）
			 * start: 表格分页（默认第一页）
			 * limit: 每页显示条数
			 * searchName: 搜索（用户名）
			 */
			tableData: [],
			loading: true,
			total: 0,
			start: 0,
			limit: 10,
			searchName: '',
			ImgDialog: false,
			currentImg: {},
            searchData: {
                name1: ''
            },

			/* 新增部分 */
			AddDialogTableVisible: false, //默认隐藏
			AddForm: {
				vr_name: '',
				vr_tntroduce: '',
				vr_icon: [],
				vr_issupport: [],
				vr_url: ''
			},
			addUploadFileList: [],

			/* 查看详情部分 */
			DetailDialogTableVisible: false,
			DetailForm: {
				vr_name: '',
				vr_tntroduce: '',
				vr_icon: [],
				vr_issupport: [],
				vr_url: ''
			},
			detailUploadFileList: [],

			/* 编辑部分 */
			EditDialogTableVisible: false,
			EditForm: {
				vr_name: '',
				vr_tntroduce: '',
				vr_icon: [],
				vr_issupport: [],
				vr_url: ''
			},
			editUploadFileList: [],


			Rules: {
				vr_name: [{required: true, message: '请输入VR名称', trigger: 'blur'}],
				vr_tntroduce: [{required: false, message: '请输入介绍', trigger: 'blur'}],
				vr_icon: [{required: true, message: '请选择图标', trigger: 'change'}],
				vr_issupport : [{required: true, message : '请选择VR体验', trigger: 'change'}],
				vr_url: [{required: true, validator: checkURL, trigger: 'blur'}]
			},
			UploadUrl: `${api.dev}/p/vote/manager/uploadFile?access_token=${getToken()}`, // 上传图片路径

			permissionShow: false, // 默认为false,根据权限是否显示
			permissionEdit: false, // 默认为false,根据权限是否修改
			permissionAdd: false, // 默认为false,根据权限是否新建
			permissionDetail: false, // 默认为false,根据权限是否查看
			permissionDelete: false, // 默认为false,根据权限是否删除
		}
	},
	methods: {
		getLimit(){
			this.$http.post(
				`${api.dev}/p/main/preference/show`,
				{
					access_token: getToken(),
				},
				{emulateJSON : true}
			).then(res => {
				if(res.body.code == 200) {
					this.limit = (res.body.content) ? res.body.content.p_pagesize : 10;
					this.getInfo();
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					this.getInfo();
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'})
					},2000)
				}
			})
		},
		/* 获取权限 */
		getSubPermission() {
			this.$http.get(
				`${api.dev}/p/permission/getSub`,
				{
					params:{
						access_token:getToken(),
						p_id: this.$route.params.id
					}
				}
			).then(res => {
				if(res.body.code == 200) {
					res.body.content.forEach(item => {
						if(item.p_name.indexOf('显示') > -1) {
							this.permissionShow = true;
						}else if(item.p_name.indexOf('修改') > -1) {
							this.permissionEdit = true;
						}else if(item.p_name.indexOf('新建') > -1) {
							this.permissionAdd = true;
						}else if(item.p_name.indexOf('查看') > -1) {
							this.permissionDetail = true;
						}else if(item.p_name.indexOf('删除') > -1) {
							this.permissionDelete = true;
						}
					})
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'})
					},2000)
				}
			})
		},
        /* 搜索 */
        handleSearch(){
            this.searchData = {
                name1: this.searchName
            };
            this.getInfo();
        },
		/* 表格数据加载 */
		getInfo(){
			this.$http.get(
				`${api.dev}/p/main/vr/show`,
				{
					params:{
						access_token: getToken(),
						start: this.start,
						limit: this.limit,
						name1: this.searchData.name1
					}
				},
				{emulateJSON : true}
			).then(res => {
				if(res.body.code == 200) {
					let json = res.body.content;
					json.records.forEach(i => {
						i.vr_icon = `${api.address}${i.vr_icon}`;
						if(i.vr_issupport == true){
							i.vr_issupport = "是"
						}else if(i.vr_issupport == false){
							i.vr_issupport = "否"
						}
					})
					this.tableData = json.records;
					this.total = json.total;
					this.loading = false;
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'})
					},2000)
				}
			})
		},
		/* 分页 */
		handleCurrentChange(val) {
			this.loading = true;
			this.start = this.limit * (val - 1);
			this.getInfo();
		},
		/* 上传图片前 */
		beforeUploadCover(file) {
			const isLt5M = file.size / 1024 / 1024  < 5;
			if (['image/jpg', 'image/jpeg', 'image/bmp','image/png'].indexOf(file.type) == -1) {
				this.$message.error('请上传正确的图片格式');
				return false;
			}
			if (!isLt5M) {
				this.$message.error('上传图片大小不能超过5MB!');
				return false;
			}
		},
		/* 放大图片 */
		handlePreview(file) {
			this.ImgDialog = true;
			this.currentImg.vr_name = '';
			this.currentImg.vr_icon = file.url;
		},
		/* 图标查看 */
		showImg(row){
			this.ImgDialog = true;
			this.currentImg = row;
		},

		/* 新增 */
		/* -新增提交- */
		submitAddForm(formName) {
			this.$refs[formName].validate((valid) => {
				if(valid) {
					// 开启加载器
					const loading = this.$loading({
						lock: true,
						text: '正在保存中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var formdata = new FormData();
					formdata.append('access_token',getToken());
					formdata.append('vr_name',this.AddForm.vr_name);
					formdata.append('vr_tntroduce',this.AddForm.vr_tntroduce);
					formdata.append('vr_icon',this.AddForm.vr_icon);
					formdata.append('vr_issupport',this.AddForm.vr_issupport);
					formdata.append('vr_url',this.AddForm.vr_url);

					this.$http.post(`${api.dev}/p/main/vr/save`,formdata, {emulateJSON:true}).then(res => {
						loading.close();
						if(res.body.code == 200) {
							this.$message({
								message: res.body.msg,
								type: 'success'
							})
							this.AddDialogTableVisible = false;
							this.loading = true;
							this.getInfo();
							this.$refs[formName].resetFields(); // 清除表单验证规则 清空表单数据
						}else if(res.body.code == 500) {
							this.$message({
								message: res.body.msg,
								type: 'error'
							});
						}else if(res.body.code == 510) {
							this.$message({
								message: res.body.msg,
								type: 'error'
							});
							removeToken();
							setTimeout(function () {
								this.$router.push({path: '/login'})
							},2000)
						}
					})
				}
			})
		},
		/* -取消新增- */
		cancleAddForm(formName) {
			this.addUploadFileList = [];
			this.$refs[formName].resetFields(); // 清除表单验证规则
			this.AddDialogTableVisible = false;
		},
		customUploadCover(options){  
        //console.log(options);
        const formdata = new FormData();
        formdata.append('file', options.file);
        // 添加其他参数
        formdata.append('access_token', getToken());    
        this.$http.post(options.action,formdata,{emulateJSON:true}).then(res => {        
                if(res.body.code==500 || res.body.code==510)
                {   this.$refs.AddUpload.uploadFiles.splice(this.$refs.AddUpload.uploadFiles.indexOf(), 1);//移除预览文件
                  this.$message({
                            message: res.body.msg,
                            type: 'error'
                        });
                    return false;
                }
                else
                {
					this.AddForm.vr_icon.push(res.body.content); 
                }  
        });       
      },
		/* -上传成功后图片的处理函数 -- 广告轮播- */
		// handleAddUploadSuccess(res,file,fileList) {
		// 	this.AddForm.vr_icon.push(res.content);
		// },
		/* -删除图片的回调函数 -- 广告轮播- */
		handleAddUploadRemove(file,fileList) {
			this.AddForm.vr_icon = [];
		},

		/* 查看 */
		/* -详情加载- */
		handleDetail(row) {
			this.$http.get(
				`${api.dev}/p/main/vr/select`,
				{
					params:{
						access_token: getToken(),
						vr_id: row.vr_id
					}
				},
				{emulateJSON : true}
			).then(res => {
				if(res.body.code == 200) {
					var data = res.body.content;
					this.DetailForm = data;
					if(data.vr_issupport) {
						data.vr_issupport = '1';
					}else{
						data.vr_issupport = '0';
					}
					this.DetailDialogTableVisible = true;
					this.detailUploadFileList.push({url: `${api.address}${data.vr_icon}`});
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'})
					},2000)
				}
			})
		},
		/* -取消查看- */
		cancleDetailForm(formName) {
			this.DetailDialogTableVisible = false;
			this.detailUploadFileList = [];
		},

		/* 编辑 */
		/* 通知修改加载 */
		handleEdit(row) {
			this.$http.get(
				`${api.dev}/p/main/vr/select`,
				{
					params:{
						access_token: getToken(),
						vr_id: row.vr_id
					}
				},
				{emulateJSON : true}
			).then(res => {
				if(res.body.code == 200) {
					var data = res.body.content;
					this.EditForm = data;
					if(data.vr_issupport) {
						data.vr_issupport = '1';
					}else{
						data.vr_issupport = '0';
					}
					this.EditDialogTableVisible = true;
					this.editUploadFileList = [{url: `${api.address}${data.vr_icon}`}];
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'})
					},2000)
				}
			})
		},
		/* 编辑提交 */
		submitEditForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if(valid) {
					// 开启加载器
					const loading = this.$loading({
						lock: true,
						text: '正在保存中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var formdata = new FormData();
					formdata.append('access_token',getToken());
					formdata.append('vr_name',this.EditForm.vr_name);
					formdata.append('vr_tntroduce',this.EditForm.vr_tntroduce);
					formdata.append('vr_icon',this.EditForm.vr_icon);
					formdata.append('vr_issupport',this.EditForm.vr_issupport);
					formdata.append('vr_url',this.EditForm.vr_url);
					formdata.append('vr_id',this.EditForm.vr_id);

					this.$http.post(
						`${api.dev}/p/main/vr/update`,
						formdata,
						{emulateJSON:true}
					).then(res => {
						loading.close();
						if(res.body.code == 200) {
							this.cancleEditForm(formName)
							this.$message({
								message: res.body.msg,
								type: 'success'
							});
							this.loading = true;
							this.getInfo();
						}else if(res.body.code == 500) {
							this.$message({
								message: res.body.msg,
								type: 'error'
							});
							this.loading = false;
						}else if(res.body.code == 510) {
							this.$message({
								message: res.body.msg,
								type: 'error'
							});
							removeToken();
							setTimeout(function () {
								this.$router.push({path: '/login'})
							},2000)
						}
					})
			  }else {
				  console.log('error submit');
				  return false;
			  }
		  })
		},
		EditUploadCover(options){   
        const formdata = new FormData();
        formdata.append('file', options.file);
        // 添加其他参数
        formdata.append('access_token', getToken());    
        this.$http.post(options.action,formdata,{emulateJSON:true}).then(res => {        
                if(res.body.code==500 || res.body.code==510)
                {   this.$refs.EditUpload.uploadFiles.splice(this.$refs.EditUpload.uploadFiles.indexOf(), 1);//移除预览文件
                  this.$message({
                            message: res.body.msg,
                            type: 'error'
                        });
                    return false;
                }
                else
                {
					this.EditForm.vr_icon.push(res.body.content);
                   
                }  
        });       
      },
		/* -上传成功后图片的处理函数 -- 广告轮播- */
		// handleEditUploadSuccess(res,file,fileList) {
		// 	this.EditForm.vr_icon.push(res.content);
		// },
		/* -删除图片的回调函数 -- 广告轮播- */
		handleEditUploadRemove(file,fileList) {
			 this.EditForm.vr_icon = [];
		},
		/* -取消编辑- */
		cancleEditForm(formName) {
			this.EditDialogTableVisible = false;
			this.editUploadFileList = [];
			this.EditForm.vr_icon = [];
		},

		/* 删除 */
		handleDelete(row) {
			var prompt = '您确认删除【 ' + row.vr_name + ' 】？';
			this.$confirm(prompt, '提示', {
				type: 'warning'
			}).then(() => {
				this.loading = true;
				this.$http.post(
					`${api.dev}/p/main/vr/delete`,
					{
						access_token : getToken() ,
						vr_id : row.vr_id
					},
					{emulateJSON : true}
				).then(res => {
					if(res.body.code == 200) {
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						if(this.start == this.total - 1){
							this.start = this.start - this.limit;
							if(this.start < 0){
								this.start = 0;
							}
						}
						this.getInfo();
					}else if(res.body.code == 500) {
						this.$message({
							message: res.body.msg,
							type: 'error'
						});
						this.loading = false;
					}else if(res.body.code == 510) {
						this.$message({
							message: res.body.msg,
							type: 'error'
						});
						removeToken();
						setTimeout(function () {
							this.$router.push({path: '/login'})
						},2000)
					}
				})
			})
		},
	},
	created() {
		this.getSubPermission();
		this.getLimit();
	},
	computed: {
		uploadDisabled1:function() {
			return this.AddForm.vr_icon.length > 0;
		},
		uploadDisabled2:function() {
			return this.DetailForm.vr_icon.length > 0;
		},
		uploadDisabled3:function() {
			return this.EditForm.vr_icon.length > 0;
		},
	}
}
</script>

<style lang="stylus" scoped>
.vrMGT{

}
</style>
<style lang="stylus">
.vrMGT{
	textarea{
		resize: none;
	}
}
</style>
